<template>
	<div class="w-full mt-5">
		<vs-row>
			<vs-col class="mb-6 md:mb-0 px-2" vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6">
			<Number :typeInput="inputType" v-model="properties.minValue" label="Valor mínimo" :min="0" :max="maxi"  @blur="validateMin"/>
			</vs-col>
			<vs-col vs-justify="center" vs-align="center" vs-w="6" vs-sm="12" vs-lg="6" class="px-2">
			<Number :typeInput="inputType" v-model="properties.maxValue" label="Valor maximo" :min="mini" @blur="validateMax"/>
			</vs-col>
		</vs-row>
	</div>

</template>

<script type="text/javascript">
	import  Number  from '../../../components/Number.vue';
	import { mapState } from 'vuex';

	export default {
		components: { Number },
		props: {
			properties: {
				type: Object,
				required: false,
				default: {}
			},
			inputType: {
				type: String,
				required: false,
				default: 'number'
			}
		},
		watch: {
			maxi: function(value) {
				let valueMax = value
				if(this.inputType === 'currency') {
					valueMax = new Intl.NumberFormat("de-DE").format(valueMax);
					this.properties.max = valueMax.length;
				}else if(this.inputType === 'number') {
					this.properties.max = String(valueMax).length;
				}
			},
			mini: function(value) {
				let valueMin = value
				if(this.inputType === 'currency') {
					valueMin = new Intl.NumberFormat("de-DE").format(valueMin);
					this.properties.min = valueMin.length;
				}else if(this.inputType === 'number') {
					this.properties.min = String(valueMin).length;
				}
			}
		},
		methods: {
            /**
             * Valida que el valor máximo sea mayor al mínino
             */
			validateMax() {
				if(this.maxi < this.mini) {
					this.properties.maxValue = this.mini;
				}
			},
            /**
             * Valida que el valor mínimo sea menor al máximo.
             */
			validateMin() {
				if(this.mini > this.maxi) {
					this.properties.minValue = this.maxi;
				}
			}
		},
		computed: {
			...mapState('resource',['questionsByPage']),
            /**
             * Obtiene el valor maximo de la propiedad
             */
			maxi() {
				return this.properties.maxValue;
			},
            /**
             * Obtiene el valor mínimo de la propiedad.
             */
			mini() {
				return this.properties.minValue;
			}
		}
	}
</script>
